import {Pipe, PipeTransform} from '@angular/core';
import {layoutPaths} from '../../../theme';

@Pipe({name: 'ubiProfilePicture'})
export class UbiProfilePicturePipe implements PipeTransform {

  transform(input: string, ext = 'png'): string {
    return layoutPaths.images.profile + input + '.' + ext;
  }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/pipes/ubiProfilePicture/ubiProfilePicture.pipe.ts